import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { UWRequirementActionEvent, UWRequirementTableData } from '@Underwriting/models';

import { UWRequirementTableActions, UWRequirementTableProps } from '../uw-requirements-expand-table';
import { SharedModule } from '@Shared/shared.module';
import { UWRequirementsActionsItemAgentCommunicationsComponent } from '../uw-requirements-actions-item-agent-communications/uw-requirements-actions-item-agent-communications.component';


@Component({
    selector: 'uw-requirements-actions-not-ordered',
    templateUrl: './uw-requirements-actions-not-ordered.component.html',
    styleUrls: ['./uw-requirements-actions-not-ordered.component.scss'],
    imports: [
       SharedModule,
       forwardRef(() => UWRequirementsActionsItemAgentCommunicationsComponent)]
})
export default class UWRequirementsActionsNotOrderedComponent {
    @Input() caseRequirement: UWRequirementTableData;
    @Input() props: UWRequirementTableProps;
    @Output() onMenuAction = new EventEmitter<UWRequirementActionEvent>();

    public get UWRequirementTableActions() {
        return UWRequirementTableActions;
    }

    handleMenuAction(columnAction: UWRequirementTableActions, caseRequirement: UWRequirementTableData) {
        const actionEvent: UWRequirementActionEvent = {
            action: columnAction,
            data: caseRequirement
        };
        this.onMenuAction.emit(actionEvent);
    }
}
